import Link from 'next/link';
import { UiButtonLabel } from '@/components/ui/UiButtonLabel';
import { ChatPanel } from './ChatPanel';
import { CHAT_WIDGET_COPY } from './chat-widget.constants';

type ChatConsentPromptProps = {
    id: string;
    privacyHref?: string;
    onStart: () => void;
    onClose: () => void;
};

/** Explains the transfer before the first request to ChatWerk; starting grants the service. */
export function ChatConsentPrompt({ id, privacyHref, onStart, onClose }: ChatConsentPromptProps) {
    return (
        <ChatPanel id={id} title={CHAT_WIDGET_COPY.consentTitle} onClose={onClose}>
            <p className="mt-2 text-sm text-(--muted)">
                {CHAT_WIDGET_COPY.consentText}
                {privacyHref ? (
                    <>
                        {' '}
                        {CHAT_WIDGET_COPY.privacyPrefix}{' '}
                        <Link href={privacyHref} className="underline underline-offset-2 hover:text-(--text)">
                            {CHAT_WIDGET_COPY.privacyLinkText}
                        </Link>
                        .
                    </>
                ) : null}
            </p>
            <button type="button" onClick={onStart} className="btn btn-primary mt-4 w-full">
                <UiButtonLabel>{CHAT_WIDGET_COPY.start}</UiButtonLabel>
            </button>
        </ChatPanel>
    );
}
